<div class="log-item" *ngIf="log">

  <!-- Icon -->
  <div class="icon">
    <sg2-user-icon class="user-icon" *ngIf="user" [user]="user"></sg2-user-icon>

    <ng-container [ngSwitch]="log.type">
      <mat-icon *ngSwitchCase="'change'">edit</mat-icon>
      <mat-icon *ngSwitchCase="'created'">content_paste</mat-icon>
      <mat-icon *ngSwitchCase="'comment'">comment</mat-icon>
      <mat-icon [class.no-user-icon]="!user" *ngSwitchDefault>history</mat-icon>
    </ng-container>
  </div>

  <!-- Message -->
  <div class="content">
    <div><strong>{{ user?.fullName }}</strong></div>
    <div class="text-capitalize"><em>{{ log.date | dateAgo }}</em></div>
    <div class="text" [innerHTML]="log.text | safeHtml"></div>
  </div>

</div>
